import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useIsOnHold from '~/hooks/vdp/selectors/useIsOnHold';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';

export default function useSetAvailabilityDataDogContext() {
  const { data, hasEverLoaded } =
    useContext(UserVehicleContext).vehicleAvailability;
  const isVehicleOnHold = useIsOnHold();
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();

  useEffect(() => {
    if (hasEverLoaded) {
      datadogRum.setGlobalContextProperty(
        'isCondensedHero',
        shouldRenderCondensedHero
      );
      datadogRum.setGlobalContextProperty('vehicleLockType', data?.lockType);
      datadogRum.setGlobalContextProperty('isVehicleOnHold', isVehicleOnHold);
    }
  }, [
    data?.lockType,
    hasEverLoaded,
    isVehicleOnHold,
    shouldRenderCondensedHero
  ]);
}
